import React from 'react';

const LoadingMovie=() => <h2>Loading Movie</h2>

export default LoadingMovie;
